import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Box, Tabs, Tab, Paper, Typography, useTheme } from '@mui/material';
import { PaymentOnboarding } from '../../../components/payment/PaymentOnboarding';
import { InvoicesList } from '../../../components/payment/InvoicesList';
// TODO: Uncomment when backend is ready
// import { WalletDashboard } from '../../../components/payment/WalletDashboard';
// import { TransactionHistory } from '../../../components/payment/TransactionHistory';
import { RefundsList } from '../../../components/payment/RefundsList';
import { usePayments } from '../../../hooks/payment/usePayments';

const PaymentSettingsView: React.FC = () => {
  const theme = useTheme();
  const location = useLocation();
  const navigate = useNavigate();

  const { settings, refreshSettings } = usePayments();

  useEffect(() => {
    refreshSettings();
  }, [refreshSettings]);

  const isOnboarded = settings?.onboardingStatus === 'COMPLETE';

  // Debug log to help troubleshoot
  useEffect(() => {
    console.log('Payment Settings:', {
      onboardingStatus: settings?.onboardingStatus,
      chargesEnabled: settings?.chargesEnabled,
      isOnboarded,
      currentPath: location.pathname,
    });
  }, [settings, isOnboarded, location.pathname]);

  // Determine current tab based on route
  const getCurrentTab = () => {
    const path = location.pathname;
    if (path.includes('/setup')) return 0;
    if (path.includes('/invoices')) return 1;
    // TODO: Uncomment when backend is ready
    // if (path.includes('/wallet')) return 2;
    // if (path.includes('/transactions')) return 3;
    if (path.includes('/refunds')) return 2;
    return 0;
  };

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    const paths = [
      '/dashboard/payment/setup',
      '/dashboard/payment/invoices',
      // TODO: Uncomment when backend is ready
      // '/dashboard/payment/wallet',
      // '/dashboard/payment/transactions',
      '/dashboard/payment/refunds',
    ];
    navigate(paths[newValue]);
  };

  // When not onboarded, show simple setup view without tabs or wrapper
  if (!isOnboarded) {
    return (
      <Box>
        <Typography variant="h4" gutterBottom fontWeight={700}>
          Payment
        </Typography>
        <PaymentOnboarding />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom fontWeight={700}>
        Payment
      </Typography>

      <Paper elevation={0} sx={{ border: `1px solid ${theme.palette.divider}` }}>
        <Tabs
          value={getCurrentTab()}
          onChange={handleTabChange}
          sx={{ borderBottom: `1px solid ${theme.palette.divider}` }}
        >
          <Tab label="Setup" />
          <Tab label="Invoices" />
          {/* TODO: Uncomment when backend is ready */}
          {/* <Tab label="Wallet" /> */}
          {/* <Tab label="Transactions" /> */}
          <Tab label="Refunds" />
        </Tabs>

        <Box sx={{ p: 3 }}>
          <Routes>
            <Route path="/" element={<Navigate to="setup" replace />} />
            <Route path="setup" element={<PaymentOnboarding />} />
            <Route path="invoices" element={<InvoicesList />} />
            {/* TODO: Uncomment when backend is ready */}
            {/* <Route path="wallet" element={<WalletDashboard />} /> */}
            {/* <Route path="transactions" element={<TransactionHistory />} /> */}
            <Route path="refunds" element={<RefundsList />} />
          </Routes>
        </Box>
      </Paper>
    </Box>
  );
};

export default PaymentSettingsView;
